// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsMedicalFSA = {
  benefits_section_medical_fsa: {
    contentful_name: '[DEFAULT] Benefits Section - Medical FSA',
    standalone_fsa_title: '医疗保健FSA',
    lpfsa_title: '医疗保健有限用途FSA',
    uses_federal_max_body:
      '您每年最多可向FSA账户缴纳联邦限额{limit}。如果您已婚,您的配偶也可以通过其雇主单独缴纳,同样最高可达联邦限额。',
    not_federal_max_body:
      '您每年最多可以向FSA账户缴纳{limit}。如果您已婚,您的配偶可以通过其雇主单独缴纳,最高可达联邦限额{fedLimit}。',
    limited_purpose_uses_federal_max_body:
      '您每年最多可向有限用途FSA账户缴存联邦限额{limit}。如果您已婚,您的配偶也可以通过其雇主单独缴存至其账户,同样不超过联邦限额。',
    limited_purpose_not_federal_max_body:
      '您每年最多可向有限用途FSA账户缴存{limit}。如果您已婚,您的配偶可以通过其雇主单独缴存至其账户,最高可达联邦限额{fedLimit}。',
    minimum_contribution_info: '此账户还要求每年至少缴纳{min}。',
    has_rollover_body: '您最多可以将{amount}的剩余资金转入下一计划年度,但超出部分将会失效。',
    no_rollover_body:
      '此账户中的资金遵循"用完或失效"原则,这意味着您必须在截止日期前花完账户中的所有资金,否则将失效。',
    federal_contribution_limit: 3400,
    limited_purpose:
      'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
  },
};
